import React, { useEffect, useState } from "react";
import {getAuthorization} from "../../../../axios/AxiosAut";
import BOMTable, {
  AvatarCell,
  SelectColumnFilter,
  StatusPill,
} from "./BOMTable"; // new

function SelectionsTableData() {
  const [Items, setItems] = useState();
  useEffect(() => {
    getAuthorization()
      .get("product/all_products/?product_type=item")
      .then((res) => {
        setItems(res.data);
      })
      .catch((err) => [console.log("err", err)]);
  }, []);

  const columns = React.useMemo(
    () => [
      {
        Header: "Item Name",
        accessor: "name",
        // Cell: StatusPill,
      },
      {
        Header: "Product ID",
        accessor: "product_id",
      },
      {
        Header: "Product Type",
        accessor: "product_type",
      },
    ],
    []
  );

  return (
    <div className="">
      <main className="max-w-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="mt-3 flex">
          <BOMTable columns={columns} data={Items == undefined ? [] : Items} />
        </div>
      </main>
    </div>
  );
}

export default SelectionsTableData;
